import { Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

export const HintTrigger = styled(Inscription)`
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-skip-ink: auto;
  text-underline-position: from-font;
  text-decoration-color: ${({ theme }) => theme.colors.border};
  cursor: default;
`;
